/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable eqeqeq */

const normalSueIDs = {
  area: 433, // 展区或参会指南
  album: 434, // 外部云摄影
  diffSch: 377, // 特殊排课
  collection: 396 // 推荐位id合集
}

const urlNew = {
  // getWechatCode: 'https://www.msup.com.cn/api/api-common/get-top100-qrcode', // 获取登录二维码
  // wechatLogin: 'https://www.msup.com.cn/api/api-common/top100-poll', // 微信登录轮询
  getWechatCode: 'https://www.msup.com.cn/api/api-common/get-qrcode-universal', // 获取登录二维码
  pcLogin: 'https://www.msup.com.cn/api/api-common/poll-universal', // 登录轮询
  sendCode: 'https://www.msup.com.cn/api/login/send-captcha', // 发送手机验证码
  sendCaptcha: 'https://www.msup.com.cn/login/default/send-captcha', // 发送手机验证码
  bindPhone: 'https://www.msup.com.cn/api/cecc-api/bind-phone', // 绑定手机号
  getUserSetting: 'https://www.msup.com.cn/api/top-api/user-set', // 获取用户个人信息
  special: 'https://www.msup.com.cn/api/api-common/get-diys-data', // 检查优惠(qd渠道码)
  getMyOrder: 'https://www.msup.com.cn/api/top-api/get-order', // 获取我的订单
  getMyOrderUniversal: 'https://www.msup.com.cn/api/api-common/get-order-universal', // 获取我的订单(new)
  getMyTicket: 'https://www.msup.com.cn/api/api-common/get-all-ticket', // 获取门票
  getMyActiveTicket: 'https://www.msup.com.cn/api/api-common/get-all-activation-ticket', // 获取门票
  getMyTicketUniversal: 'https://www.msup.com.cn/api/api-common/get-ticket-universal', // 获取门票(new)
  getMyInvoice: 'https://www.msup.com.cn/api/top-api/get-invoice', // 获取发票
  applyInvoice: 'https://www.msup.com.cn/api/top-api/apply-invoice', // 申请发票
  isVip: 'https://www.msup.com.cn/api/api-common/is-vip', // 会员信息(是否为会员)
  checkLook: 'https://www.msup.com.cn/api/top-api/check-look', // 直播观看权限
  createOrder: 'https://www.msup.com.cn/api/api-common/create-order-of-top', // 创建订单
  createOrderGoods: 'https://www.msup.com.cn/api/api-common/create-order-and-order-goods', // 创建订单(专属订单)
  payStands: 'https://www.msup.com.cn/shopping/default/pay-stands', // 订单支付平台
  payStatus: 'https://www.msup.com.cn/api/pay/order-pay-status?order=', // 订单支付状态
  checkHash: 'https://www.msup.com.cn/api/api-common/check-order-diys-by-params', // 判断hash是否有效
  checkCaptcha: 'https://www.msup.com.cn/login/default/check-captcha', // 校验验证码（qd购票使用）
  //
  sue: {
    type: 'https://api.msup.com.cn/sue/get-sue-type/', // 推荐位类型
    all: 'https://api.msup.com.cn/sue/get-all-sue-info/', // 推荐位
    lecturer: 'https://api.msup.com.cn/sue/obtain-sue-lecturer/', // 出品人(列表)
    arr: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/' // 数组输出
  },
  speaker: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/', // 演讲嘉宾(列表)
  lecturer: 'https://api.msup.com.cn/lecturer/view/', // 讲师信息
  // subject: 'https://api.msup.com.cn/group/get-group-project/', // 专题(列表)
  subject: 'https://api.msup.com.cn/group/get-group-project-new/', // 专题(列表)[新/备用]
  subject_detail: 'https://api.msup.com.cn/group/group-project-info/', // 专题详情
  course: {
    course: 'https://api.msup.com.cn/course/view/', // 课程信息
    all: 'https://api.msup.com.cn/scheduling/get-all-courses/', // 全部课程(列表)
    video: 'https://api.msup.com.cn/course/video-list/',
    ppt: 'https://www.msup.com.cn/api/api-common/get-course-ppt-universal' // 课程课件
  },
  schedule: 'https://api.msup.com.cn/scheduling/get-schedule/', // 日程
  schedule_group: 'https://api.msup.com.cn/scheduling/get-schedule-by-group/', // 日程
  schedule_final: 'https://api.msup.com.cn/scheduling/get-schedule-final/', // 日程
  place: 'https://www.msup.com.cn/api/api-common/get-simple-scheduling-data?sid=', // 时间、地点
  order: 'https://www.msup.com.cn/api/api-common/tickets-info',
  poster: {
    info: 'https://www.msup.com.cn/api/api-common/get-card-title-by-scheduling-id?sid=',
    active: 'https://www.msup.com.cn/api/api-common/get-card-info',
    analysis: 'https://www.msup.com.cn/api/api-common/card-analysis'
  },
  universal: { // 会议网站通用接口 get参数：choose(1-默认官网|2-小程序) token(官网) userId(小程序) loginTime(小程序登录时间)
    ticket: 'https://www.msup.com.cn/api/api-common/get-ticket-universal', // "获取门票": sid(大会id) flag(1-默认我购买的|2-全部的) type(官网会议类型:all-默认全部|top100|cecc)
    order: 'https://www.msup.com.cn/api/api-common/get-order-universal', // "获取订单": sid(大会id) source(订单来源:0-默认全部|1-其他会议|2-cecc) type(类型:0-默认全部|1-已支付|2-待支付)
    invoice: 'https://www.msup.com.cn/api/api-common/get-invoice-universal', // "获取发票": sid(大会id) source(订单来源:0-默认全部|1-其他会议|2-cecc)
    invoiceDetail: 'https://www.msup.com.cn/api/api-common/invoice-detail-universal', // "发票详情": invoiceId(发票id)
    invoiceApply: 'https://www.msup.com.cn/api/api-common/apply-invoice-universal', // "申请发票"
    invoiceCancel: 'https://www.msup.com.cn/api/api-common/cancel-invoice-universal', // "取消发票": invoiceId(发票id)
    coursePPT: 'https://www.msup.com.cn/api/api-common/get-course-ppt-universal', // "获取课件": sid(大会id) cid(课程id)
    pptGoodsId: 'https://www.msup.com.cn/api/api-common/get-goods-id-of-ppt', // 获取ppt关联商品id
    pptBuy: 'https://www.msup.com.cn/api/api-common/is-buy-ppt', // 判断是否已购买ppt
    pptOrder: 'https://www.msup.com.cn/api/api-common/create-ppt-order-of-top', // 购买ppt生成ppt商品订单
    pptOrderDetail: 'https://www.msup.com.cn/api/api-common/get-meeting-resource' // 获取已购票或已购买ppt的打包下载链接
  },
  collect: {
    check: 'https://www.msup.com.cn/api/api-common/favourite-verify-universal?choose=1',
    change: 'https://www.msup.com.cn/api/api-common/set-favourite-universal?choose=1',
    get: 'https://www.msup.com.cn/api/api-common/get-favourite-list-universal?choose=1'
  }
}

const url = {
  form_url: 'https://acrm.msup.com.cn/form/detail?form_id=',
  place: 'https://www.msup.com.cn/api/api-common/get-simple-scheduling-data?sid=',
  course_detail: 'https://api.msup.com.cn/course/view/',
  teacher_detail: 'https://api.msup.com.cn/lecturer/view/',
  schedule: 'https://api.msup.com.cn/scheduling/get-schedule/',
  project: 'https://api.msup.com.cn/group/get-group-project/',
  project_new: 'https://api.msup.com.cn/group/get-group-project-new/',
  review: 'https://api.msup.com.cn/the-venue/get-previous-meeting',
  order: {
    url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
    url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
    url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/',
    user: 'https://www.msup.com.cn/api/top-api/get-order',
    create: 'https://www.msup.com.cn/api/api-common/create-order-of-top' // 生成订单
  },
  ticket: {
    all: 'https://www.msup.com.cn/api/api-common/get-all-ticket',
    my: 'https://www.msup.com.cn/api/api-common/get-all-activation-ticket',
    info: 'https://www.msup.com.cn/api/api-common/tickets-info'
  },
  invoice: {
    open: 'https://www.msup.com.cn/api/top-api/apply-invoice'
  },
  getjssdk: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config',
  // index
  // 获取本次大会所有的老师
  lecturers: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
  // 获取本次大会所有的专题
  venues: 'https://api.msup.com.cn/scheduling/get-all-venues/',
  // 获取本次大会历史赞助媒体
  history_ad: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
  // 获取本次大会赞助媒体sponsor
  sponsor: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
  // 获取本次会议的所有课程
  course: 'https://api.msup.com.cn/scheduling/get-all-courses/',
  gettype: 'https://api.msup.com.cn/sue/get-all-sue-info/',
  user: {
    info: 'https://www.msup.com.cn/api/top-api/user-set'
  },
  poster: {
    info: 'https://www.msup.com.cn/api/api-common/get-card-title-by-scheduling-id',
    active: 'https://www.msup.com.cn/api/api-common/get-card-info'
  },
  checkhash: 'https://www.msup.com.cn/api/api-common/check-order-diys-by-params' // 判断hash是否有效
}

const config = {
  // 2010   223 212 213
  '223': {
    title: '北京',
    adId: '82',
    jieshu: '1',
    year: '2010',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '223'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '223'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '212': {
    title: '上海',
    adId: '82',
    jieshu: '2',
    year: '2010',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '212'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '212'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '213': {
    title: '北京',
    adId: '82',
    jieshu: '3',
    year: '2010',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '213'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '213'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2011   207 172 211 208 209
  '207': {
    title: '北京',
    adId: '82',
    jieshu: '4',
    year: '2011',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '207'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '207'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '172': {
    title: '上海',
    adId: '82',
    jieshu: '6',
    year: '2011',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '172'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '172'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '211': {
    title: '深圳',
    adId: '82',
    jieshu: '6',
    year: '2011',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '211'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '211'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '208': {
    title: '成都',
    adId: '82',
    jieshu: '7',
    year: '2011',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '208'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '208'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '209': {
    title: '济南',
    adId: '82',
    jieshu: '8',
    year: '2011',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '209'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '209'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2012   162 164 163 166 168 167 165 169 171
  '162': {
    title: '北京',
    adId: '82',
    jieshu: '9',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '162'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '162'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '164': {
    title: '上海',
    adId: '82',
    jieshu: '10',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '164'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '164'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '163': {
    title: '武汉',
    adId: '82',
    jieshu: '11',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '163'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '163'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '166': {
    title: '大连',
    adId: '82',
    jieshu: '12',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '166'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '166'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '168': {
    title: '深圳',
    adId: '82',
    jieshu: '13',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '168'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '168'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '167': {
    title: '成都',
    adId: '82',
    jieshu: '14',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '167'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '167'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '165': {
    title: '西安',
    adId: '82',
    jieshu: '15',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '165'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '165'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '169': {
    title: '南京',
    adId: '82',
    jieshu: '16',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '169'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '169'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '171': {
    title: '厦门',
    adId: '82',
    jieshu: '17',
    year: '2012',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '171'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '171'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2013   158 159 161 205
  '158': {
    title: '北京',
    adId: '82',
    jieshu: '18',
    year: '2013',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '158'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '158'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '159': {
    title: '上海',
    adId: '82',
    jieshu: '19',
    year: '2013',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '159'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '159'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '161': {
    title: '深圳',
    adId: '82',
    jieshu: '20',
    year: '2013',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '161'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '161'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '205': {
    title: '成都',
    adId: '82',
    jieshu: '21',
    year: '2013',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '205'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '205'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2014   148 149
  '148': {
    title: '北京',
    adId: '82',
    jieshu: '22',
    year: '2014',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '148'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '148'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '149': {
    title: '上海',
    adId: '82',
    jieshu: '23',
    year: '2014',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '149'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '149'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2015   31 44 128 147
  '31': {
    title: '北京',
    adId: '82',
    jieshu: '24',
    year: '2015',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '31'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '31'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '44': {
    title: '上海',
    adId: '82',
    jieshu: '25',
    year: '2015',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '44'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '44'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '128': {
    title: '深圳',
    adId: '82',
    jieshu: '26',
    year: '2015',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '128'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '128'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '147': {
    title: '南京',
    adId: '82',
    jieshu: '27',
    year: '2015',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '147'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '147'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2016   206 215 216 217 296 361
  '206': {
    title: '深圳',
    adId: '82',
    jieshu: '28',
    year: '2016',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '206'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '206'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '215': {
    title: '北京',
    adId: '82',
    jieshu: '29',
    year: '2016',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '215'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '215'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '216': {
    title: '上海',
    adId: '82',
    jieshu: '30',
    year: '2016',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '216'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '216'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '217': {
    title: '成都',
    adId: '82',
    jieshu: '31',
    year: '2016',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '217'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '217'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '296': {
    title: '福州',
    adId: '82',
    jieshu: '32',
    year: '2016',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '296'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '296'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '361': {
    title: '南京',
    adId: '82',
    jieshu: '33',
    year: '2016',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '361'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '361'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2017   435 445 443 599 827
  '435': {
    title: '上海',
    adId: '82',
    jieshu: '34',
    year: '2017',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '435'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '435'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '445': {
    title: '深圳',
    adId: '82',
    jieshu: '35',
    year: '2017',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '445'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '445'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '443': {
    title: '北京',
    adId: '82',
    jieshu: '36',
    year: '2017',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '443'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '443'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '599': {
    title: '厦门',
    adId: '82',
    jieshu: '37',
    year: '2017',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '599'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '599'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  '827': {
    title: '成都',
    adId: '82',
    jieshu: '38',
    year: '2017',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '827'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '827'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },

  // 2018北京站
  '1038': {
    title: '北京',
    adId: '82',
    jieshu: '43',
    year: '2018',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '1038'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '1038'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2018上海站
  '1014': {
    title: '上海',
    adId: '84',
    jieshu: '45',
    year: '2018',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '1014'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":92}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":84}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '99'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '1014'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2018深圳
  '1058': {
    title: '深圳',
    adId: '83',
    jieshu: '44',
    year: '2018',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '1058'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":93}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":83}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '98'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '1058'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2018 成都
  '1270': {
    title: '成都',
    adId: '124',
    jieshu: '46',
    year: '2018',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '2078'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":83}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '98'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '1270'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 北京站ID 1683
  '1683': {
    title: '北京',
    adId: '82',
    jieshu: '43',
    year: '2019',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '1683'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":82}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '90'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '1683'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 上海站ID 1688
  '1688': {
    title: '上海',
    adId: '84',
    jieshu: '45',
    year: '2019',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '1688'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":92}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":84}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '99'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '1688'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 深圳站ID 1687
  '1687': {
    title: '深圳',
    adId: '83',
    jieshu: '44',
    year: '2019',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '1687'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":93}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":83}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '98'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '1687'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 成都站ID 2078
  '2078': {
    title: '成都',
    adId: '124',
    jieshu: '46',
    year: '2019',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '2078'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":83}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '98'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '2078'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2020成都站
  '2252': {
    title: '成都',
    adId: '82',
    trueplace: '',
    jieshu: '48',
    year: '2020',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '2252'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":83}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '98'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '2252'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2020深圳站
  '2251': {
    title: '深圳',
    adId: '82',
    trueplace: '',
    jieshu: '49',
    year: '2020',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '2251'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":83}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '98'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '2251'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2020上海站
  '2250': {
    title: '上海',
    adId: '82',
    trueplace: '',
    jieshu: '48',
    year: '2020',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '2250'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"sponsor":83}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '98'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '2250'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },
  // 2020北京站
  '2249': {
    title: '北京',
    // "adId": "82",
    adId: '173',
    trueplace: '国际会议中心',
    jieshu: '47',
    year: '2020',
    index: {
      // 获取本次大会所有的老师
      lecturers: {
        url: 'https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/',
        id: '2249'
      },
      // 获取本次大会所有的专题
      venues: {
        url: 'https://api.msup.com.cn/scheduling/get-all-venues/',
        id: ''
      },
      // 获取本次大会历史赞助媒体
      history_ad: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        id: '{"history_ad":91}'
      },
      // 获取本次大会赞助媒体sponsor
      sponsor: {
        url: 'https://api.msup.com.cn/sue/obtain-sue-by-arr/',
        // "id": '{"sponsor":83}'
        id: '{"sponsor":173}'
      },
      // 获取本次会议的所有课程
      course: {
        url: 'https://api.msup.com.cn/scheduling/get-all-courses/',
        id: '98'
      },
      gettype: {
        url: 'https://api.msup.com.cn/sue/get-all-sue-info/'
      }
    },
    course_detail: {
      url: 'https://api.msup.com.cn/course/view/'
    },
    teacher_detail: {
      url: 'https://api.msup.com.cn/lecturer/view/'
    },
    schedule: {
      url: 'https://api.msup.com.cn/scheduling/get-schedule/',
      id: '2249'
    },
    review: {
      url: 'https://api.msup.com.cn/the-venue/get-previous-meeting'
    },
    order: {
      url: 'https://www.msup.com.cn/shopping/default/shopping-tickect',
      url_experience: 'https://api.msup.com.cn/ticket/get-tickets/',
      url_by_lecturer: 'https://api.msup.com.cn/ticket/get-tickets-by-lecturer/'
    },
    getjssdk: {
      url: 'https://api.msup.com.cn/wechat-msup/get-jssdk-config'
    }
  },

  // 2021天津 2690
  '2690': {
    title: '天津',
    adId: '82',
    trueplace: '',
    jieshu: '50',
    year: '2021'
  },
  // 2021上海 2691
  '2691': {
    title: '上海',
    adId: '82',
    trueplace: '',
    jieshu: '49',
    year: '2021',
    form_id: 16
  },
  // 2021北京 2721
  '2721': {
    title: '北京',
    adId: '82',
    trueplace: '',
    jieshu: '50',
    year: '2021',
    form_id: 17
  },
  // 2021大连 2762
  '2762': {
    title: '大连',
    adId: '82',
    trueplace: '',
    jieshu: '51',
    year: '2021',
    form_id: 22
  },
  // 2021成都 2942
  '2942': {
    title: '成都',
    adId: '82',
    trueplace: '',
    jieshu: '52',
    year: '2021',
    form_id: 51
  },
  // 2022广州 2940（删）
  '2940': {
    title: '广州',
    adId: '82',
    trueplace: '',
    jieshu: '53',
    year: '2022',
    form_id: 50
  },
  // 2022大连 3204（已弃用）
  '3204': {
    title: '大连',
    adId: '82',
    trueplace: '',
    jieshu: '53',
    year: '2022',
    form_id: 52
  },
  // 2022成都 3427
  '3427': {
    title: '成都',
    adId: '82',
    trueplace: '',
    jieshu: '54', // 届数
    year: '2022', // 年份
    form_id: 70, // 咨询表单id
    isuser: true, // 是否需要用户中心
    haslive: false, // 是否直播（有直播时同时需要有用户中心）
    livevod: 0, // 直播是否正在回放（0-否，1-是）
    livetype: 0, // 直播类型（0-直播助手无聊天室，1-线上直播有聊天室）
    livemenu: 1, // 是否关闭直播页 提问/反馈 等功能（若开启可不设置此项 即undefined）
    project_schedule_times: ['09:00', '13:30', '09:00', '13:30'] // 专题下课程开始时间
  },
  // 2022北京 3357
  '3357': {
    title: '北京',
    adId: '82',
    trueplace: '',
    jieshu: '53', // 届数
    year: '2022', // 年份
    form_id: 68, // 咨询表单id
    isuser: true, // 是否需要用户中心
    haslive: true, // 是否直播（有直播时同时需要有用户中心）
    livevod: 1, // 直播是否正在回放（0-否，1-是）
    livetype: 0, // 直播类型（0-直播助手无聊天室，1-线上直播有聊天室）
    livemenu: 1, // 是否关闭直播页 提问/反馈 等功能（若开启可不设置此项 即undefined）
    project_schedule_times: ['09:00', '13:30', '16:50', '09:00', '13:30'] // 专题下课程开始时间
  },
  // 2024
  '4224': {
    link: 'https://a2m.msup.com.cn/home?aid=4288',
    title: '北京',
    adId: '82', // 赞助商
    trueplace: '',
    trueTitle: '2024年 A2M x MPD 北京站',
    jieshu: '55', // 届数
    year: '2024', // 年份
    starttime: '8.23', // 开始日期-暂无排课时显示
    endtime: '24', // 结束日期-暂无排课时显示
    base: { groups: 4, teachers: 20, days: 2 }, // 专场数、讲师数、天数
    form_id: '90', // 咨询表单id
    isuser: true, // 是否需要用户中心
    haslive: false, // 是否直播（有直播时同时需要有用户中心）
    livevod: 0, // 直播是否正在回放（0-否，1-是）
    livetype: 0, // 直播类型（0-直播助手无聊天室，1-线上直播有聊天室）
    livemenu: 1, // 是否关闭直播页 提问/反馈 等功能（若开启可不设置此项 即undefined）
    project_schedule_times: ['09:00', '13:30', '16:50', '09:00', '13:30'] // 专题下课程开始时间
  },
  // 'cd': {
  //   title: '成都',
  //   adId: '82', // 赞助商
  //   trueplace: '',
  //   jieshu: '56', // 届数
  //   year: '2024', // 年份
  //   form_id: '', // 咨询表单id
  //   isuser: true, // 是否需要用户中心
  //   haslive: false, // 是否直播（有直播时同时需要有用户中心）
  //   livevod: 0, // 直播是否正在回放（0-否，1-是）
  //   livetype: 0, // 直播类型（0-直播助手无聊天室，1-线上直播有聊天室）
  //   livemenu: 1, // 是否关闭直播页 提问/反馈 等功能（若开启可不设置此项 即undefined）
  //   project_schedule_times: ['09:00', '13:30', '16:50', '09:00', '13:30'] // 专题下课程开始时间
  // },
  // 2026
  '4886': {
  // '4535': {
    title: '上海',
    adId: '82', // 赞助商(旧key)
    sponser: '453', // 赞助商
    history: '', // 往届赞助商
    chairman: '438', // 联席主席
    lecturer: '437', // 出品人
    case: '439', // 精选案例
    recommend: '440', // 推荐案例
    opening: '441', // 开幕式
    trueplace: '',
    jieshu: '56', // 届数
    year: '2026', // 年份
    address: '2026sh',
    form_url: 'http://p.msup.cn/3os8', // 咨询表单链接
    form_id: '', // 咨询表单id https://vip.msup.com.cn/index.php/weixin/feedback/form-feedback?formId=4478
    isuser: true, // 是否需要用户中心
    haslive: false, // 是否直播（有直播时同时需要有用户中心）
    livevod: 0, // 直播是否正在回放（0-否，1-是）
    livetype: 0, // 直播类型（0-直播助手无聊天室，1-线上直播有聊天室）
    livemenu: 1, // 是否关闭直播页 提问/反馈 等功能（若开启可不设置此项 即undefined）
    project_schedule_times: ['09:00', '13:30', '16:50', '09:00', '13:30'], // 专题下课程开始时间
    invitation: 'https://f.msup.com.cn/c/MPD2026%20%E4%B8%8A%E6%B5%B7%E7%AB%99%E9%82%80%E8%AF%B7%E5%87%BD.pptx', // 邀请函链接
    collect_case: 'http://p.msup.cn/te4u', // 案例征集
    collect_producer: 'http://p.msup.cn/ALDM' // 出品人邀请
  }
}

const company_phone = ['400-8128-020', '130-4321-8801', '159-0023-2589']
// const companyPhone = ["139-2085-9305", "130-4321-8801"]

const card_keyword = { subject: ['专题详情', '专题'], course: ['课程详情', '课程'], case: ['精选案例', '案例'], schedule: ['日程安排', '日程'] }
// { subject: '专题', course: '课程', case: '案例', schedule: '日程' } // 卡片关键字

// const area_id = ((_arr)=>{
//   let arr = [];
//   for(let i of _arr){
//     arr.push(parseInt(i));
//   }
//   return arr.sort((a,b)=>{return b-a;});
// })(Object.keys(config))[0]; // 取最近的area_id

// const area_id = '4224'
// const limitYear = '2024'
const area_id = '4886' // 当前大会id（确保是最新一期大会且在config中存在）
const limitYear = '2026' /* 2026年起从工作坊改为大会 */
var year = (config[area_id] && config[area_id].year) || new Date().getFullYear() // 当前大会年份
year = year.toString().trim()
var address = config[area_id] && (config[area_id].address || (year + (config[area_id].jieshu || area_id))) // 当前大会年份+地址简写
address = address.toString().trim()
var id_list = config[area_id]

var feedback_pop_id = '263' // 直播反馈赞助商图片

const configYear = {}
for (let sid of Object.keys(config)) {
  let k = config[sid].address || (config[sid].year + (config[sid].jieshu || sid))
  configYear[k] = { ...config[sid], sid }
}

export {
  url,
  urlNew,
  normalSueIDs,
  config,
  configYear,
  company_phone,
  card_keyword,
  area_id,
  year,
  address,
  limitYear,
  id_list,
  feedback_pop_id
}



// WEBPACK FOOTER //
// ./src/api.js